// extracted by mini-css-extract-plugin
module.exports = {"root":"login-module--root--23Fq6"};